import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findArList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/ar/list?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2ReceiverAgentStatistics = (params) => { //新进销存应收款列表
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentStatistics?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2ReceiverAgentStatisticsDownload = (params) => { //新进销存应收款列表
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentStatistics/downloadExcel?` + params,
        method: 'GET'
    })
}


export const findArDetail = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/ar/detail?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2ReceiverAgentDetail = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentDetail/${id}?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2ReceiverAgentDetailDownload = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentDetail/downloadExcel/${id}?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2Purchase = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/purchase/${id}`,
        method: 'GET'
    })
}

export const findStockRemovalDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/detail/${id}`,
        method: 'GET',
    })
}
export const downloadPDF = (id) => {
    let url = `${baseUrl}` + `/joins-invoice-system/v1/purchase/exportPdfPurchaseDetail/${id}`
    window.open(url);
}
export const stockRemovalReturn = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/dissident/${id}?` + params,
        method: 'GET'
    })
}
export const stockRemoval = (ids) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/removal/${ids}`,
        method: 'PUT'
    })
}